const doc = [({"se":({"models":({"team_survey_step":({"doesnt_belong_to_the_same_survey":"tillhör inte samma undersökning: %{survey_name}"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;